import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  DevNote,
  FormFieldSet,
  LogoLoader,
  TableAdv,
  showToast,
  StatusTags,
  useFormHandler,
  SmartTooltip,
} from "../../../../components";
import qb from "../../../../assets/qb.svg";
import { dateFormator, mapTableRows } from "../../../../utils";
import { DropDownoptionsquickbooks } from "../../../../assets/data/projectData";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../hooks";
import {
  clearVendorData,
  getVendorsStart,
} from "../../../../redux/slices/vendor/vendorSlice";
import { getVendorId } from "../../../../utils/getClientId";
import { WORKFORCE_API_URL } from "../../../../redux/apiConfig";
import axios from "axios";
import QbAnimationLoading from "../../../../components/Module/Invoices/InvoiceModals/QbAnimationLoading";

const Vendors = ({ setActiveTab, dropdowns }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [sortConfig, setSortConfig] = useState({
    field: "uiid",
    direction: -1,
  });
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [forceRerenderKey, setForceRerenderKey] = useState(0);
  const [qbLoading, setQbLoading] = useState(false);

  const { loading, error, vendors, totalCount } = useSelector(
    (state) => state.vendor
  );

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      dispatch(
        getVendorsStart({
          page: newPage,
          limit: newLimit,
          // filters: { "placements.0": { type: "EXISTS", value: 1 } },
          filters: {},
          ret: "",
          sort: { uiid: -1 },
          ref: "PlacementWithEmp",
          incl: "employeeId jobInfo.startDate jobInfo.jobTitle",
        })
      );
    }
  );

  //const tablerowData = accountPayables;
  const tablerowData = vendors?.data || []; // Add null check with default empty array
  // Handle sort function
  const handleSort = (field) => {
    setSortConfig((prevSort) => ({
      field,
      // Toggle between 1 (ascending) and -1 (descending)
      direction: prevSort.field === field ? -prevSort.direction : -1,
    }));
  };

  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    Placement: "",
    documentType: "",
    status: "",
  });
  //   const columns = [
  //     {
  //       key: "invoiceNumber",
  //       label: "Invoice Number",
  //       sortable: false,
  //     },

  //     {
  //       key: "businessUnit",
  //       label: "Business Unit",
  //       sortable: false,
  //     },
  //     {
  //       key: "recordType",
  //       label: "Record Type",
  //       sortable: false,
  //     },
  //     {
  //       key: "vendor",
  //       label: "Vendor",
  //       sortable: false,
  //     },
  //     {
  //       key: "employees",
  //       label: "Employees",
  //       sortable: false,
  //     },
  //     {
  //       key: "invoicDate",
  //       label: "Invoice Date",
  //       sortable: false,
  //     },
  //     {
  //       key: "dueDate",
  //       label: "Due Date",
  //       sortable: false,
  //     },

  //     {
  //       key: "invoiceAmount",
  //       label: "Invoice Amount",
  //       sortable: false,
  //     },
  //     {
  //       key: "paidAmount",
  //       label: "Paid Amount",
  //       sortable: false,
  //     },

  //     {
  //       key: "syncstatus",
  //       label: "Sync Status",
  //       sortable: false,
  //     },
  //   ];

  const columns = [
    // { key: "slno", label: "Sl No" },
    {
      key: "businessName",
      label: "Business Name",
      width:"min-w-[250px] max-w-[350px]",
      render: (row) => (
        <SmartTooltip
          description={row.businessName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
        <div
          className={`flex gap-2 items-center cursor-pointer ${
            row?.qbSync?.id
              ? "text-success"
              : row?.qbSync?.error
              ? "text-danger"
              : "text-linkblue"
          } `}
        >
          <Avatar
            alt={row.businessName}
            size="sm"
            contain
            src={row.profileImage}
          />
          <div className="line-clamp-1!">{row.businessName}</div>
        </div>
        </SmartTooltip>
      ),
    },
    {
      key: "vendorId",
      label: "Vendor ID",
      render: (row) => (
        <div className="flex items-center gap-1">
          <span className="text-linkblue">
            {/* <Link to="/vendor/vendor-details" state={{ code: row.uiid }}> */}
            {`VEN-${row.uiid}`}
            {/* </Link> */}
          </span>
        </div>
      ),
    },

    {
      key: "netTerms",
      label: "Net Terms",
      render: (row) => (
        <div className="flex items-center gap-1">
          <span className="">
            {/* <span className="text-linkblue"> */}
            {row.generalInfo?.netTerms || "-"}
          </span>
        </div>
      ),
    },
    {
      key: "employeeStatus",
      label: "Status",
      render: (row) => (
        <StatusTags
          tag={row.generalInfo?.recordStatus === 1 ? "Active" : "Inactive"}
        />
      ),
    },
    {
      key: "syncstatus",
      label: "Sync Status",
      render: (row) => <div>{row?.qbSync?.id ? "Synced" : "Unsynced"}</div>,
      sortable: false,
    },
    // {
    //   key: "contactNo",
    //   label: "Contact No",
    //   render: (row) => (
    //     <div className="flex items-center gap-1">
    //       <span className="">
    //         {/* <span className="text-linkblue"> */}
    //         {row.contact?.code && row.contact?.number
    //           ? row.contact?.code + "-" + row.contact?.number
    //           : "-"}
    //       </span>
    //     </div>
    //   ),
    // },
    // {
    //   key: "emailId",
    //   label: "Email ID",
    //   render: (row) => (
    //     <div className="flex items-center gap-1">
    //       <span className="">
    //         {/* <span className="text-linkblue"> */}
    //         {row.email}
    //       </span>
    //     </div>
    //   ),
    // },

    // {
    //   key: "",
    //   label: "Action",
    //   render: (row) => (
    //     <Button
    //       type="icon"
    //       variant="text"
    //       icon="filter_alt"
    //       size="sm"
    //       color="black"
    //       onClick={() => handleEdit(row)}
    //     />
    //   ),
    //   sortable: false,
    // },
  ];

  const rowdata = [
    {
      invoiceNumber: "INV-2001",
      businessUnit: "Tektree",
      recordType: "Ap invoice",
      vendor: "ABC Vendors Pvt Ltd",
      employees: "John Doe, Jane Smith",
      invoicDate: "06/01/2025",
      dueDate: "06/30/2025",
      invoiceAmount: "45,000 USD",
      paidAmount: "45,000 USD",
      syncstatus: "Not Synced",
    },
    {
      invoiceNumber: "INV-2002",
      businessUnit: "Tektree",
      recordType: "Ap invoice",
      vendor: "XYZ Supplies",
      employees: "Emily Clark",
      invoicDate: "06/10/2025",
      dueDate: "07/10/2025",
      invoiceAmount: "25,000 USD",
      paidAmount: "10,000 USD",
      syncstatus: "Not Synced",
    },
    {
      invoiceNumber: "INV-2003",
      businessUnit: "Tektree",
      recordType: "Ap invoice",
      vendor: "TechWave LLC",
      employees: "Arjun Reddy, Ravi Teja",
      invoicDate: "06/15/2025",
      dueDate: "06/30/2025",
      invoiceAmount: "60,000 USD",
      paidAmount: "60,000 USD",
      syncstatus: "Not Synced",
    },
  ];

  const rowData2 = tablerowData?.map((item) => ({
    id: item?.uiid,
    uiid: item?.uiid,
    qbSync: item?.qbSync,
    businessName: item?.businessName,
    // netTerms: item?.generalInfo?.netTerms,
    generalInfo: item?.generalInfo,
    // syncstatus: item?.qbSync?.id ? "Synced" : "Unsynced",
  }));
  const mappedRows = mapTableRows(rowData2, columns);

  useEffect(() => {
    dispatch(
      getVendorsStart({
        page: page,
        limit: limit,
        filters: {},
        sort: { uiid: -1 },
        ret: "",
        ref: "PlacementWithEmp",
        incl: "employeeId jobInfo.startDate jobInfo.jobTitle",
      })
    );
    return () => {
      dispatch(clearVendorData());
    };
  }, [dispatch, page, limit, forceRerenderKey]);

  const handleSearch = () => {
    setActiveTab(Number(formData.Timesheets));
  };

  const forceRerender = () => {
    setForceRerenderKey((prevKey) => prevKey + 1);
  };

  // const handleQbSync = async () => {
  //   if (selectedRowIds.length === 0) {
  //     showToast("Please select at least one invoice", "info", 5000);
  //     return;
  //   }

  //   let baseUrl = WORKFORCE_API_URL;
  //   let successCount = 0;
  //   let failedCount = 0;

  //   try {
  //     setQbLoading(true);

  //     const selectedIds = selectedRowIds;
  //     const vendorData = tablerowData?.filter((invoice) =>
  //       selectedIds.includes(invoice.uiid)
  //     );

  //     const buildVendorPayload = (data) => ({
  //       postActions: ["AddQBToVendor"],
  //       payload: {
  //         businessName: (data.businessName || "").replace(/[^\w\s]/g, ""),
  //         uiid: data.uiid || null,
  //         dbaName: data?.dbaName || "",
  //         email: data?.email,
  //         phone: data?.phone,
  //         website: data?.website,
  //         generalInfo: {
  //           locations: data?.generalInfo?.locations,
  //           recorsStatus: data?.generalInfo?.recordStatus,
  //         },
  //       },
  //     });

  //     for (const vendor of vendorData) {
  //       const vendorData = vendor || {};
  //       const isVendorSynced = Boolean(vendorData?.qbSync?.id);

  //       if (!isVendorSynced) {
  //         try {
  //           const vendorPayload = buildVendorPayload(vendorData);
  //           await axios.post(`${baseUrl}/qb/vendors`, vendorPayload, {
  //             headers: { "Content-Type": "application/json" },
  //             withCredentials: true,
  //           });
  //           successCount++;
  //         } catch (err) {
  //           console.error("Vendor Sync Failed:", err.response || err);
  //           failedCount++;
  //         }
  //       }
  //     }
  //   } catch (err) {
  //     console.error("Unexpected QB Vendor Sync Error:", err);
  //   } finally {
  //     setQbLoading(false);
  //     forceRerender();
  //     showToast(
  //       `QB Vendor Sync Completed: ${successCount} succeeded, ${failedCount} failed.`,
  //       failedCount > 0 ? "warning" : "success",
  //       6000
  //     );
  //   }
  // };


  const handleQbSync = async () => {
  if (selectedRowIds.length === 0) {
    showToast("Please select at least one invoice", "info", 5000);
    return;
  }

  const baseUrl = WORKFORCE_API_URL;
  setQbLoading(true);

  const selectedIds = selectedRowIds;
  const vendorData = tablerowData?.filter((invoice) =>
    selectedIds.includes(invoice.uiid)
  );

  const axiosConfig = {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  };

  const buildVendorPayload = (data, isUpdate = false) => ({
    ...(isUpdate && { update: true }),
    postActions: ["AddQBToVendor"],
    payload: {
      qbSync: data.qbSync || null,
      businessName: (data.businessName || "").replace(/[^\w\s]/g, ""),
      uiid: data.uiid || null,
      dbaName: data.dbaName || "",
      email: data.email,
      phone: data.phone,
      website: data.website,
      generalInfo: {
        locations: data.generalInfo?.locations || [],
        recorsStatus: data.generalInfo?.recordStatus || null,
      },
    },
  });

  const results = await Promise.allSettled(
    vendorData.map(async (vendor) => {
      const isSynced = Boolean(vendor?.qbSync?.id);
      const payload = buildVendorPayload(vendor, isSynced);
      try {
        await axios.post(`${baseUrl}/qb/vendors`, payload, axiosConfig);
        return "success";
      } catch (err) {
        showToast(`${err?.response?.data?.error || "Unknown error"}`, "warning", 5000);
        console.error("Vendor Sync Failed:", err.response || err);
        return "fail";
      }
    })
  );

  const successCount = results.filter((r) => r.status === "fulfilled" && r.value === "success").length;
  const failedCount = results.length - successCount;

  setQbLoading(false);
  forceRerender();
  showToast(
    `QB Vendor Sync Completed: ${successCount} succeeded, ${failedCount} failed.`,
    failedCount > 0 ? "warning" : "success",
    6000
  );
};

  return (
    <div className="flex flex-col overflow-hidden flex-1">
      <QbAnimationLoading
        isOpen={qbLoading}
        onClose={() => setQbLoading(false)}
      />
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <TableAdv
        tableId={"invoices_qbintegration_vendors"}
        onSelectionChange={(ids) => setSelectedRowIds(ids)}
        rows={mappedRows}
        columns={columns}
        showCheckbox
        serverPagination={true}
        totalCount={totalCount?.data}
        page={page}
        limit={limit}
        defaultSelectedRows={selectedRowIds}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={{
          search: false,
          filter: false,
          download: false,
          add: [
            {
              component: (
                <div className=" flex gap-3 m-2 flex-wrap items-center ">
                  <FormFieldSet
                    type="text"
                    noTitle
                    placeholder="Invoice No, Client, Employee"
                    value={formData.Search || ""}
                    onChange={(value) => handleChange("Search", value)}
                    error={errors.Search}
                  />
                  <FormFieldSet
                    type="select"
                    noTitle
                    placeholder="Select Timesheets"
                    value={formData.Timesheets || ""}
                    // onChange={(value) => setActiveTab(value)}
                    onChange={(value) => handleChange("Timesheets", value)}
                    error={errors.Timesheets}
                    options={dropdowns}
                  />
                  <FormFieldSet
                    type="select"
                    noTitle
                    placeholder="Select Status"
                    value={formData.status || ""}
                    onChange={(value) => handleChange("status", value)}
                    error={errors.status}
                    options={""}
                    showSearch
                  />
                  
                    <Button title="Search" onClick={handleSearch} />
                  
              
                    <Button
                      title="QB Integration Profiles"
                      color="info"
                      onClick={() =>
                        navigate("/quickbooks/qb-integration-profile")
                      }
                    />
                
                  <div className="mt-5 flex items-center">
                    {selectedRowIds.length > 0 && (
                      <>
                        {/* <button onClick={() => handleQbSync()} className="mx-1">
                          <Avatar src={qb} alt={"qb"} size="xs" outline />
                        </button>*/}
                      </>
                    )}
                  </div>
                </div>
              ),
            },
          ],
        }}
      />
    </div>
  );
};

export default Vendors;
